/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FieldRefDto } from './FieldRefDto';
import type { NestedIntFilterDto } from './NestedIntFilterDto';
export type IntFilterDto = {
  /**
   * Equals
   */
  equals?: number | FieldRefDto;
  /**
   * In array
   */
  in?: Array<number> | FieldRefDto;
  /**
   * Not in array
   */
  notIn?: Array<number> | FieldRefDto;
  /**
   * Less than
   */
  lt?: number | FieldRefDto;
  /**
   * Less than or equal
   */
  lte?: number | FieldRefDto;
  /**
   * Greater than
   */
  gt?: number | FieldRefDto;
  /**
   * Greater than or equal
   */
  gte?: number | FieldRefDto;
  /**
   * Not
   */
  not?: number | NestedIntFilterDto;
  /**
   * Query mode (default, insensitive)
   */
  mode?: IntFilterDto.mode;
};
export namespace IntFilterDto {
  /**
   * Query mode (default, insensitive)
   */
  export enum mode {
    DEFAULT = 'default',
    INSENSITIVE = 'insensitive',
  }
}
